import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getHeaderTitle", "actionMetadata", "flowObjectTypeId", "actionId"];
import PropTypes from 'prop-types';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import RotateObjectActionMetadata from 'automation-ui-action-features/actions/rotate-object/RotateObjectActionMetadata';
import RotateObjectActionSummary from 'automation-ui-action-features/actions/rotate-object/RotateObjectActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
function RotateObjectActionCard(_ref) {
  let {
      getHeaderTitle,
      actionMetadata,
      flowObjectTypeId,
      actionId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId
    }),
    content: /*#__PURE__*/_jsx(RotateObjectActionSummary, {
      actionMetadata: actionMetadata,
      flowObjectTypeId: flowObjectTypeId
    })
  }));
}
RotateObjectActionCard.propTypes = {
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  actionMetadata: PropTypes.instanceOf(RotateObjectActionMetadata).isRequired,
  flowObjectTypeId: ObjectTypeIdType.isRequired,
  getHeaderTitle: PropTypes.func.isRequired
};
export default RotateObjectActionCard;